window.handleCaptchaResponse = function () {
	const captcha = document.getElementById('sib-captcha');

	if (captcha) {
		captcha.dispatchEvent(new Event('captchaChange'));
	}

	window.grecaptcha = window.turnstile;
};

window.REQUIRED_CODE_ERROR_MESSAGE = 'Bitte wählen Sie eine Länderkennung';
window.LOCALE = 'de';
window.EMAIL_INVALID_MESSAGE = window.SMS_INVALID_MESSAGE = 'Die eingegebenen Informationen sind ungültig. Bitte überprüfen Sie das Format des Feldes und versuchen Sie es erneut.';
window.REQUIRED_ERROR_MESSAGE = 'Dieses Feld darf nicht leer sein.';
window.GENERIC_INVALID_MESSAGE = 'Die eingegebenen Informationen sind ungültig. Bitte überprüfen Sie das Format des Feldes und versuchen Sie es erneut.';
window.INVALID_NUMBER = 'Die eingegebenen Informationen sind ungültig. Bitte überprüfen Sie das Format des Feldes und versuchen Sie es erneut.';
window.INVALID_DATE = 'Bitte geben Sie ein gültiges Datum ein';
window.REQUIRED_MULTISELECT_MESSAGE = 'Bitte wählen Sie mindestens 1 Option';
window.translation = {
	common: {
		selectedList: '{quantity} Liste ausgewählt',
		selectedLists: '{quantity} Listen ausgewählt',
		selectedOption: '{quantity} ausgewählt',
		selectedOptions: '{quantity} ausgewählt',
	},
};
window.AUTOHIDE = false;
